import { bindInPageLinks, focusHash } from "@shopify/theme-a11y";
import "vanilla-lazyload/dist/lazyload.min.js";
import "slick-carousel/slick/slick.js";
import { registerBundle } from "scripts/lib/register-bundle.js";
focusHash();
bindInPageLinks();
registerBundle("vendors@layout.theme");
